export const AUTHORIZED_MODULE = 'AUTHORIZED';
export const SYSTEM_MODULE = 'SYSTEM';
export const GUEST_MODULE = 'GUEST';
export const USER_MODULE = 'USER';
export const ROLE_MODULE = 'USER_ROLE_MODULE';
export const NOTIFICATION = 'NOTIFICATION';
export const DASHBOARD_MODULE = 'DASHBOARD_MODULE';
export const SESSION_MODULE = 'SESSION_MODULE';
export const ZONES_MODULE = 'ZONES_MODULE';
export const SYSTEM_EVENTS_MODULE = 'SYSTEM_EVENTS_MODULE';
export const SETTINGS_MODULE = 'SETTINGS_MODULE';
export const METROLOGY_MODULE = 'METROLOGY_MODULE';
export const DETECTION_MODULE = 'DETECTION_MODULE';
export const WEB_SOCKET_MODULE = 'WEB_SOCKET_MODULE';
